import { bridge } from "@dinahmoe/dmafjs-core";

import { VisualSuper } from "./visual-super.component.js";

class HtmlViewer extends VisualSuper {
  namespace = "visual:htmlViewer";

  clear(cNode) {
    bridge.update({
      uid: "visual/" + cNode.uid,
      key: "clear",
      sender: "core",
    });
  }
}

const htmlViewer = new HtmlViewer();
export { HtmlViewer, htmlViewer };
